module.exports = __webpack_public_path__ + "media/src/fonts/Lora-Regular-604c086e88aa8418edee4332c73a1062.woff2";